var _style, _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoloHiloIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 370 370",
    style: {
      enableBackground: "new 0 0 370 370"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E6EEF4;}\n\t.st1{fill:#D71F00;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 185,
    cy: 185,
    r: 185
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M211.5,238.1L211.5,238.1c0,0,44.5,44.5,79.7-8.9c18.4-27.7,5.9-54.8-13.7-73.5l-84.2-82.9c-4.8-4-12-4-16.8,0 l-85.4,82.9c-16.8,17.6-31.2,45.7-12.6,73.5c35.5,53.2,79.7,8.9,79.7,8.9c0,22.7-6.5,51.9-8.3,59.9c-0.3,1.1,0.6,2.1,1.7,2.1H218 c1.2,0,2-1,1.7-2.1C218,290,211.5,260.7,211.5,238.1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoloHiloIcon);
export default __webpack_public_path__ + "static/media/yolo_hilo_icon.922fec6b5e2a1443a665c1f4e8ec329c.svg";
export { ForwardRef as ReactComponent };